import { createAction, props } from '@ngrx/store';

export const getDeviceModels = createAction('[DeviceModels] Get');
export const storeDeviceModels = createAction('[DeviceModels] Store', props<{ list: any }>());
